import type { QueryClient, QueryKey } from "@tanstack/react-query";

/**
 * refetch reads queries again after a write, cancelling any read of them still
 * in flight first.
 *
 * `invalidateQueries` alone is not enough while a query's **first** read is in
 * flight: with no data cached yet React Query does not replace that fetch, it
 * joins it (`Query.fetch` cancels a running fetch only when `data` is
 * defined), so the read that left before the write becomes the cached answer
 * and nothing reads again. Cancelling first reverts the query to "never
 * fetched", and the invalidate then starts a read that sees the write.
 *
 * Seen three times: a collection made while the admin page loaded (10-18), a
 * tag the same way, and the studio's publish tool saying "up to date" after a
 * chapter rename made just after the page loaded (10-25, auth.spec).
 */
export async function refetch(client: QueryClient, ...keys: QueryKey[]) {
  await Promise.all(keys.map((queryKey) => client.cancelQueries({ queryKey })));
  await Promise.all(keys.map((queryKey) => client.invalidateQueries({ queryKey })));
}
